import { render, staticRenderFns } from "./ShiftView.vue?vue&type=template&id=6b7ea4ac&scoped=true&"
import script from "./ShiftView.vue?vue&type=script&lang=js&"
export * from "./ShiftView.vue?vue&type=script&lang=js&"
import style0 from "./ShiftView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShiftView.vue?vue&type=style&index=1&id=6b7ea4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ea4ac",
  null
  
)

export default component.exports